import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, Sms as SmsIcon} from "@mui/icons-material"
import React from "react"

import {CustomerSMSActivityPayload} from "@indebted/api"

function SMSSentActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerSMSActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
	showDeliveredAt: boolean = true,
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<SmsIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>To Number:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.ToNumber}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Text:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Text}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Initiated At:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.InitiatedAt}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Sent At:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.SentAt}</Typography>
						</div>
						{showDeliveredAt && (
							<div>
								<Typography className={classes.activityContentLabel}>Delivered At:</Typography>
								<Typography className={classes.activityContentValue}>
									{Payload.DeliveryAt || "Not Delivered"}
								</Typography>
							</div>
						)}
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {SMSSentActivity}
